import _ from 'underscore';
import cookie from 'js-cookie';
import { SessionManager, ISessionManagerOptions, ISessionInfo } from '@bingads-webui/ads-copilot-ui';

export interface IPreferenceService {
  setAtUserLevel: (value: any) => Promise<void>;
  findByNameAtUserLevel: (key: any) => any;
}

export interface IDataSessionManagerOptions extends ISessionManagerOptions {
  domain: string;
  preferenceService?: IPreferenceService;
}

// Store token in preference service
// Store all other information in cookie
export class DataSessionManager extends SessionManager {
  private domain: string;

  private preferenceService: IPreferenceService | undefined;

  constructor({
    domain,
    preferenceService,
    ...args
  }: IDataSessionManagerOptions) {
    super(args);
    this.domain = domain;
    this.preferenceService = preferenceService;
  }

  public saveSessionInfo(newInfo: ISessionInfo) {
    this.sessionInfo = _.extend({}, this.sessionInfo, newInfo);

    // hard reset token in cookie
    const dataInCookie = {
      ...this.sessionInfo,
      token: 'tokenPlaceholder',
    };

    // Storing token in cookie will trigger security leak warning. So, we are storing token in preference service
    cookie.set(this.sessionInfoKey, JSON.stringify(dataInCookie), {
      domain: this.domain,
      secure: true,
    });

    this.preferenceService?.setAtUserLevel({
      Name: this.sessionInfoKey,
      Data: this.sessionInfo?.token || '',
    });

    this.onSaveSessionInfo(this.sessionInfo, this.sessionInfoKey);
    return Promise.resolve(newInfo);
  }

  public getSessionInfo() {
    let result;

    try {
      if (this.sessionInfo == null) {
        this.sessionInfo = JSON.parse(cookie.get(this.sessionInfoKey) as string);
        const tokenData = this.preferenceService?.findByNameAtUserLevel(this.sessionInfoKey);
        const { Data: token } = tokenData || {};
        if (!_.isEmpty(token)) {
          this.sessionInfo = _.extend({}, this.sessionInfo, { token });
        }
      }
      result = this.sessionInfo;
    } catch (e) {
      result = null;
    }

    this.onGetSessionInfo(result, this.sessionInfoKey);
    return Promise.resolve(result);
  }

  public clearSessionInfo() {
    this.onClearSessionInfo(this.sessionInfo, this.sessionInfoKey);
    cookie.remove(this.sessionInfoKey);
    this.preferenceService?.setAtUserLevel({
      Name: this.sessionInfoKey,
      Data: '',
    });
    return Promise.resolve();
  }
}
